// import store from '@/store/index.js'
// let dic = store.state.dic;
import {
    getOrgOptions,
} from "@/libs/searchSelect.js";
export default function Configs(that) {

    const searchItems = [
        {
            label: "身份证号",
            span: 6,
            placeholder: '请输入身份证号',
            model: "idCard",
        },
        {
            label: "姓名",
            span: 6,
            placeholder: '请输入姓名',
            model: "studentName",
        },
        {
            label: "办理事项",
            span: 6,
            placeholder: '请选择办理事项',
            model: "linkId",
            type: "select",
            options: [],
            clearable: true,
        },
        {
            label: "办理状态",
            span: 6,
            placeholder: '请选择办理状态',
            model: "status",
            type: 'select',
            options: [{ label: '已办理', value: 1 }, { label: '未办理', value: 0 }],
            clearable: true,
        },
        {
            label: "学院",
            span: 6,
            type: 'select',
            model: "collegeId",
            options: [],
            clearable: true,
            change(data) {
                // console.log(data)
                let params = {
                    parentId: data,
                    type: 'department'
                }
                that.searchItems[5].options = [];
                that.searchItems[6].options = [];
                that.searchItems[7].options = [];
                that.pageParams.departmentId = "";
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    getOrgOptions(that, params, 5, null)
                }
            },
        },
        {
            label: "系别",
            span: 6,
            type: 'select',
            model: "departmentId",
            options: [],
            clearable: true,
            change(data) {
                let params = {
                    parentId: data,
                    type: 'major'
                }
                that.searchItems[6].options = [];
                that.searchItems[7].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    getOrgOptions(that, params, 6, null)
                }
            },
        },
        {
            label: "专业",
            span: 6,
            type: 'select',
            model: "majorId",
            options: [],
            clearable: true,
            change(data) {
                console.log(data)
                let params = {
                    parentId: data,
                    type: 'class'
                }
                that.searchItems[7].options = [];
                that.pageParams.classId = '';
                if (data) {
                    getOrgOptions(that, params, 7, null)
                }
            },
        },
        {
            label: "班级",
            span: 6,
            type: 'select',
            model: "classId",
            options: [],
            clearable: true,
        },

    ]
    const tableColumns = [
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            show: true,
            minWidth: 180,
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true
        },
        {
            label: "性别",
            prop: "sex",
            align: "center",
            show: true
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "系别",
            prop: "departmentName",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "班级",
            prop: "className",
            align: "center",
            show: true,
            minWidth: 140,
        },
        {
            label: "办理事项",
            prop: "linkName",
            align: "center",
            // width:'150px',
            show: true,
            minWidth: 140,
        },
        {
            label: "办理状态",
            prop: "status",
            align: "center",
            show: true,
            minWidth: 120,
        },
    ]

    return {
        searchItems,
        tableColumns
    }
}
